
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/reset-password",
      function () {
        return require("private-next-pages/[locale]/reset-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/reset-password"])
      });
    }
  